import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom';
import logo from '../../assets/logo.png'

const Invoice = () => {
    const { orderId } = useParams();
    const [invoice, setOrder] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    useEffect(() => {
        try {
            fetch(process.env.REACT_APP_SERVER_URL + '/orders/getInvoice', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    orderId: orderId
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if (data.success) {
                        setOrder(data.orders);

                    }
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                })
        } catch (error) {
            console.log(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (invoice.length) {
            window.print();
        }
    }, [invoice])

    return (
        <div>
            {!isLoading && <div className="mx-auto p-12" style={{ "max-width": "800px" }}>
                <div className="flex items-center justify-between mb-8 px-3">
                    <div>
                        <span className="text-2xl">Invoice #</span>: {invoice._id}<br />
                        <span>Date</span>:  {invoice.order_date}<br />
                    </div>
                    <div className="text-right  grayscale">
                        <img src={logo} alt='logo' className='h-20 w-20' />
                    </div>
                </div>

                <div className="flex justify-between mb-8 px-3">
                    <div className='w-56'>
                        {invoice.firstName + ' ' + invoice.lastName} <br />
                        {invoice.address + '-' + invoice.zip}<br />
                        {invoice.phone}
                    </div>
                    <div className="text-right">
                        Go Green<br />
                        Group - 10, MCA<br />
                        MNNIT Allahabad<br />
                        Prayagraj - 211004
                    </div>
                </div>



                <div className="">
                    <div className="flex flex-col mx-0">
                        <table className="min-w-full divide-y divide-gray-600">
                            <thead>
                                <tr>
                                    <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm   sm:pl-6 md:pl-0">
                                        Description
                                    </th>
                                    <th scope="col" className="hidden py-3.5 px-3 text-right text-sm f  sm:table-cell">
                                        Quantity
                                    </th>
                                    <th scope="col" className="hidden py-3.5 px-3 text-right text-sm   sm:table-cell">
                                        Rate
                                    </th>
                                    <th scope="col" className="py-3.5 pl-3 pr-4 text-right text-sm font-normal  sm:pr-6 md:pr-0">
                                        Amount
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoice.products.map(item => (
                                    <tr className="border-b border-slate-200">
                                        <td className="py-4 pl-4 pr-3 text-sm sm:pl-6 md:pl-0">
                                            <div className="font-medium ">{item.name}</div>
                                            <div className="mt-0.5  sm:hidden">
                                                1 unit at ₹ {item.price}
                                            </div>
                                        </td>
                                        <td className="hidden px-3 py-4 text-sm text-right  sm:table-cell">
                                            {item.quantity}
                                        </td>
                                        <td className="hidden px-3 py-4 text-sm text-right  sm:table-cell">
                                            ₹ {item.price}
                                        </td>
                                        <td className="py-4 pl-3 pr-4 text-sm text-right  sm:pr-6 md:pr-0">
                                            ₹ {item.quantity * item.price}
                                        </td>
                                    </tr>
                                ))}


                            </tbody>
                            <tfoot>
                                <tr>
                                    <th scope="row" colspan="3" className="hidden pt-6 pl-6 pr-3 text-sm font-light text-right  sm:table-cell md:pl-0">
                                        Subtotal
                                    </th>
                                    <th scope="row" className="pt-6 pl-4 pr-3 text-sm font-light text-left  sm:hidden">
                                        Subtotal
                                    </th>
                                    <td className="pt-6 pl-3 pr-4 text-sm text-right  sm:pr-6 md:pr-0">
                                        ₹ {
                                            invoice.products.map(item => (
                                                item.quantity * item.price
                                            )).reduce((a, b) => a + b, 0)
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="3" className="hidden pt-6 pl-6 pr-3 text-sm font-light text-right  sm:table-cell md:pl-0">
                                        Delivery Cost
                                    </th>
                                    <th scope="row" className="pt-6 pl-4 pr-3 text-sm font-light text-left  sm:hidden">
                                        Delivery Cost
                                    </th>
                                    <td className="pt-6 pl-3 pr-4 text-sm text-right  sm:pr-6 md:pr-0">
                                        ₹ {invoice.standardDeliveryMethod === true ? 50 : 100}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="3" className="hidden pt-6 pl-6 pr-3 text-sm font-light text-right  sm:table-cell md:pl-0">
                                        Discount
                                    </th>
                                    <th scope="row" className="pt-6 pl-4 pr-3 text-sm font-light text-left  sm:hidden">
                                        Discount
                                    </th>
                                    <td className="pt-6 pl-3 pr-4 text-sm text-right  sm:pr-6 md:pr-0">
                                        -  ₹ {invoice.discount}
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="3" className="hidden pt-4 pl-6 pr-3 text-lg text-right  sm:table-cell md:pl-0">
                                        Total
                                    </th>
                                    <th scope="row" className="pt-4 pl-4 pr-3 text-lg text-left   sm:hidden">
                                        Total
                                    </th>
                                    <td className="pt-4 pl-3 pr-4 text-lg text-right  sm:pr-6 md:pr-0">
                                        ₹ {invoice.total}
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>


                <div className="mb-8 mt-10 px-3">
                    <p className='font-mono text-xs text-justify text-gray-500'>Payment terms are 14 days. Please be aware that according to the Late Payment of Unwrapped Debts Act 0000, freelancers are entitled to claim a 00.00 late fee upon non-payment of debts after this time, at which point a new invoice will be submitted with the addition of this fee. If payment of the revised invoice is not received within a further 14 days, additional interest will be charged to the overdue account and a statutory rate of 8% plus Bank of England base of 0.5%, totalling 8.5%. Parties cannot contract out of the Act’s provisions.</p></div>

                <div className="mb-8 text-4xl text-center px-3">
                    <span>Thank you!</span>
                </div>

                <div className="text-center text-sm px-3">
                    group10@gogreen.com ∖ go-green-10.vercel.com
                </div>
            </div>}
        </div >
    )
}

export default Invoice